import { useMsal } from '@azure/msal-react';
import { AuthHelper } from '../auth/AuthHelper';
import { UserSetting, UserSettingService } from '../services/UserSettingService';
import { Preset, NewsRead } from '../services/SettingsService';

let userSettingCache: UserSetting = {
    presets: [],
    newsRead: [],
};
export const useUserSetting = () => {
    const { instance, inProgress } = useMsal();
    const userSettingService = new UserSettingService();

    const save = async () => {
        await userSettingService.save(userSettingCache, await AuthHelper.getSKaaSAccessToken(instance, inProgress));
    };

    const load = async () => {
        userSettingCache = await userSettingService.load(await AuthHelper.getSKaaSAccessToken(instance, inProgress));
    };

    const getPresets = () => {
        return userSettingCache.presets;
    };

    const setPresets = (presets: Preset[]) => {
        userSettingCache = {
            ...userSettingCache,
            presets,
        };

        void save();
    };

    const getNewsRead = () => {
        return userSettingCache.newsRead;
    };

    const setNewsRead = (newsRead: NewsRead[]) => {
        userSettingCache = {
            ...userSettingCache,
            newsRead,
        };

        void save();
    };

    return {
        init: load,
        getPresets,
        setPresets,
        getNewsRead,
        setNewsRead
    };
};
